import React, { useMemo } from "react";
import CountdownItem from "./Countdown";
import moment from "moment-timezone";
import { toMomentInUserTz, breakdownByCalendar } from "../../../../utils/time.js";

const CountdownDisplay = ({ countdown }) => {
  const userTz = moment.tz.guess();
  const targetUserTz = useMemo(() => toMomentInUserTz(countdown), [countdown]);

  const nowUserTz = moment.tz(userTz);

  const { months, weeks, days, hours, minutes, seconds } = breakdownByCalendar(
    targetUserTz,
    nowUserTz
  );

  const diff = moment.duration(targetUserTz.diff(nowUserTz));
  const totalDays = Math.floor(diff.asDays());

  const monthsRemaining = months;

  return (
    <div className="col-xl-12 wid-100 d-flex align-items-center justify-content-center">
      <div className="d-flex justify-content-center align-items-center">
        {monthsRemaining >= 6 && countdown && (
          <div className="d-flex">
            <CountdownItem
              label="Months"
              value={months}
              backgroundColor="#8B2020"
            />
            <CountdownItem
              label="Weeks"
              value={weeks}
              backgroundColor="#8B2020"
            />
            <CountdownItem
              label="Days"
              value={days}
              backgroundColor="#8B2020"
            />
            <CountdownItem
              label="Hours"
              value={hours}
              backgroundColor="#8B2020"
            />
            <CountdownItem
              label="Minutes"
              value={minutes}
              backgroundColor="#8B2020"
            />
          </div>
        )}

        {monthsRemaining >= 1 && monthsRemaining < 6 && countdown && (
          <div className="d-flex">
            <CountdownItem
              label="Months"
              value={months}
              backgroundColor="#8B2020"
            />
            <CountdownItem
              label="Weeks"
              value={weeks}
              backgroundColor="#8B2020"
            />
            <CountdownItem
              label="Days"
              value={days}
              backgroundColor="#8B2020"
            />
            <CountdownItem
              label="Hours"
              value={hours}
              backgroundColor="#8B2020"
            />
            <CountdownItem
              label="Minutes"
              value={minutes}
              backgroundColor="#8B2020"
            />
          </div>
        )}

        {monthsRemaining < 1 && countdown && (
          <div className="d-flex">
            <CountdownItem
              label="Days"
              value={totalDays}
              backgroundColor="#8B2020"
            />
            <CountdownItem
              label="Hours"
              value={hours}
              backgroundColor="#8B2020"
            />
            <CountdownItem
              label="Minutes"
              value={minutes}
              backgroundColor="#8B2020"
            />
            <CountdownItem
              label="Seconds"
              value={seconds}
              backgroundColor="#8B2020"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default CountdownDisplay;
